import api from './interceptor'

export const getSlideList = () => {
  return api.get('/website/slider/getSlideList')
}
export const getMenuList = () => {
  return api.get('/website/slider/getMenuList')
}
export const getSelectedlist = params => {
  return api.get('/loyalty/getSelectedList', { params })
}
export const getCouponList = params => {
  return api.get('/right/coupon/getCouponList', { params })
}
